export const CREATE_PRICING_PROCESS_MUTATION = `
  mutation CreatePricingProcess($template: pricing_process_insert_input!) {
    insert_pricing_process_one(object: $template) {
      id
      name
      description
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_PRICING_PROCESS_MUTATION = `
  mutation UpdatePricingProcess($id: Int!, $_set: pricing_process_set_input!) {
    update_pricing_process_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
      name
      description
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_PRICING_PROCESS_MUTATION = `
  mutation DeletePricingProcess($id: Int!) {
    delete_pricing_process_by_pk(id: $id) {
      id
    }
  }
`;
